import { Component } from '@angular/core';
import {AlertController, IonicPage, LoadingController, NavController, NavParams, ToastController} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";
import { Storage } from '@ionic/storage';
import {SocialSharing} from "@ionic-native/social-sharing";
import {DomSanitizer} from "@angular/platform-browser";
import {DataProcessModuleLogsPage} from "../data-process-module-logs/data-process-module-logs";
import {DatePipe} from "@angular/common";
import {FileTransfer, FileUploadOptions, FileTransferObject} from "@ionic-native/file-transfer";
import {File} from "@ionic-native/file";
import {AndroidPermissions} from "@ionic-native/android-permissions";

/**
 * Generated class for the DataProcessModulePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

//@IonicPage()
@Component({
  selector: 'page-data-process-module',
  templateUrl: 'data-process-module.html',
})
export class DataProcessModulePage {


  School='GEIS';
  SchoolId=1;

  StatusPending='Pending';
  pendingorCompleted=1;

  Status='Data';
  subStatusId=1;

  DataCount=0;
  AptCount=0;
  EnqCount=0;
  FBCount=0;
  Admissioncount=0;

  pendingCount=0;
  completedCount=0;

  pending:any[];
  completed:any[];

  FUserId:any;
  userName:any;

  page=1;

  IsSearch=0;


  constructor(public navCtrl: NavController, public navParams: NavParams,public sanitize:DomSanitizer,private transfer: FileTransfer,
              public service:ServiceProvider,public alertCtrl:AlertController,public storage:Storage,public file: File,private androidPermissions: AndroidPermissions,
  public loadingCtrl:LoadingController,public toastCtrl:ToastController,public socialSharing:SocialSharing,public datepipe: DatePipe)
  {
    Promise.all([this.storage.get('LoginData'),this.storage.get('UserData')]).then(values => {

      this.FUserId = values[0]['FUserId'];
      this.userName=values[1]['Name'];
      console.log(this.userName);

    });
    this.get_process_module('1');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DataProcessModulePage');
  }


  active_School_tab(tab,schoolId) {
    console.log(tab , schoolId);
    this.SchoolId=schoolId;
    this.School=tab;
    this.active_status_tab(this.Status,this.subStatusId);
    this.get_process_module('1');
  }

  active_status_pending_tab(tab,Id)
  {
    this.StatusPending=tab;
    this.pendingorCompleted=Id;
    this.get_process_module('1');

  }

  active_status_tab(tab,subId)
  {
    //this.searchText="";
    console.log(tab , subId);
    this.Status=tab;
    this.subStatusId=subId;

    this.get_process_module('1');
  }

  get_process_module(page)
  {
    this.IsSearch=0;
    this.service.httppostcall('app_web_service/get_process_module?SchoolId='+this.SchoolId+'&FStatusId='+this.subStatusId+'&page='+page,'').subscribe(data=>{

      this.IsSearch=1;
      this.pending=data['pending'];
      this.completed=data['completed'];

      this.pendingCount=data['pendingcount'];
      this.completedCount=data['completedcount'];

      this.DataCount=data['DataCount'];
      this.AptCount=data['AptCount'];
      this.EnqCount=data['EnqCount'];
      this.FBCount=data['FBCount'];
      this.Admissioncount=data['Admission'];

    })
  }


  check_whatsup(btn,item)
  {
    let number='';
    if(btn==1)
    {
      number=item['p1'];
    }

    if(btn == 2)
    {
      number=item['p2'];
    }

    if(btn==1 && item['Phone1IsWhatsApp'] == 1)
    {
      this.presentToast('Whatsup Number Already Checked');
    }
    else if(btn==2 && item['Phone2IsWhatsApp'] == 1)
    {
      this.presentToast('Whatsup Number Already Checked');
    }
    else
    {
      let myAlert = this.alertCtrl.create({
        title: 'Confirm Number On Whatsup',
        subTitle: number,
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            handler: () => {
              console.log('Cancel clicked');
            }
          },
          {
            text: 'Open Whatsup',
            handler: () => {
              this.openWhatsup(number,'');
              console.log('clicked');

            }
          },
          {
            text: 'Confirm',
            handler: () => {
              console.log('clicked');

              let data={
                'Id':item['Id'],
                'FWebEnquiry':item['FWebEnquiryId'],
                'buttonId':btn,
                'FUserId':this.FUserId,
                'FStatusId':this.subStatusId
              };

              this.service.httppostcall('app_web_service/check_number_on_whatsup',data).subscribe(data=>{
                this.presentToast(data['message']);
                this.get_process_module('1');
              });
            }
          }
        ]
      });
      myAlert.present();
    }




  }


  send_whatsapp(btn,item)
  {
    let data={
      FStatusId:this.subStatusId,
      FSchoolId:item['SchoolId'],
      FStandardId:item['FStandardId'],
      ButtonName:'w',
      ButtonId:btn
    }

    var link="http://geis.co.in/add_appointment.php?FWebEnquiryId="+item['FWebEnquiryId']+"&Name="+item['Name'];

    var rname = /#name/gi;
    var rschool = /#school/gi;
    var rsource = /#source/gi;
    var rdate = /#date/gi;
    var rstd = /#std/gi;

    var raptLink=/#aptlink/gi;
    var rlocation = /#location/gi;
    var rusername= /#user/gi;

    var raptdate=/#aptdate/gi;
    var raptdatetime = /#aptdatetime/gi;
    var rapttime = /#apttime/gi;

    var rfeedbacklink=/#feedbacklink/gi;

    var rSchoolContact1=/#ph_number_1/gi;

    var rSchoolContact2=/#ph_number_2/gi;

    var rSchoolAddress=/#address/gi;

    var feedbacklink;

    this.service.httppostcall('app_web_service/get_feedback_link?FWebEnquiryId='+item['FWebEnquiryId']+'&SchoolId='+this.SchoolId,'').subscribe(link=>{
      feedbacklink=link['link'];
    });


    console.log(item);
    this.service.httppostcall('app_web_service/get_process_message',data).subscribe(data1=>{

      var str = data1['data']['Message'] ;


      var newstr = str. replace(rname, item['Name']);
      var newstr1   = newstr. replace(rschool,item['SchoolName']);
      var newstr2 = newstr1. replace(rsource, item['Source']);
      var newstr3 = newstr2. replace(rstd, item['StandardName']);
      var newstr4 = newstr3. replace(rdate, this.datepipe.transform(item['WebEnquiryDate'],'dd-MMM-yyyy'));
      var newstr5 = newstr4. replace(raptLink, link);
      var newstr6 = newstr5. replace(rusername, this.userName);
      var newstr7 = newstr6. replace(rlocation, item['SchoolLocation']);

      var newstr8 = newstr7. replace(raptdatetime, this.datepipe.transform(item['AppointmentDate'],'dd-MMM-yyyy') +" "+ item['AppointmentFrom'] +"-"+ item['AppointmentTo']);
      var newstr9 = newstr8. replace(rapttime,item['AppointmentFrom'] +"-"+ item['AppointmentTo']);

      var newstr10 = newstr9. replace(rfeedbacklink,feedbacklink);

      var newstr11 = newstr10. replace(raptdate,this.datepipe.transform(item['AppointmentDate'],'dd-MMM-yyyy'));

      var newstr12 = newstr11.replace(rSchoolContact1,data1['SchoolContact1']);

      var newstr13 = newstr12.replace(rSchoolContact2,data1['SchoolContact2']);

      var newstr14=newstr13.replace(rSchoolAddress,data1['SchoolAddress']);




      console.log(newstr14);



      if(data1['status'] == 'success')
      {
        let myAlert = this.alertCtrl.create({
          title: 'Select Number',
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel',
              handler: () => {
                console.log('Cancel clicked');
              }
            },
            {
              text: 'Send',
              handler: (number) => {

                if(number == undefined || number == 'null' || number == 'undefined' )
                {
                  this.presentToast('Please Select Number');
                }
                else
                {

                  let postdata={
                    'Id':item['Id'],
                    'buttonId':btn,
                    'FUserId':this.FUserId,
                    'FStatusId':this.subStatusId,
                    'UpdatedByName':this.userName
                  }

                  this.service.httppostcall('app_web_service/update_whatsup_send',postdata).subscribe(data=>{
                    //this.get_process_module();
                    console.log("Message Type:- "+ data1['data']['MsgType']);
                    if(data1['data']['MsgType'] == 1)
                    {
                      this.openWhatsup(number,newstr14);
                    }
                    else if(data1['data']['MsgType'] == 2)
                    {
                      this.openWhatsup_Image(number,data1['url']+data1['data']['File']);
                    }
                    else if(data1['data']['MsgType'] == 3)
                    {
                      this.openWhatsup_Image(number,data1['url']+data1['data']['PDF']);
                    }

                  this.get_process_module('1');
                  });

                }


              }
            }
          ]
        });

        if(item.Phone1IsWhatsApp== 1 && item.p1) {
          myAlert.addInput({
            type: 'radio',
            label: item.p1,
            value: item.p1
          })
        }

        if(item.Phone2IsWhatsApp== 1 && item.p2){
          myAlert.addInput({
            type: 'radio',
            label: item.p2,
            value: item.p2
          })
        }



        myAlert.present();
      }
      else
      {
        this.presentToast("Error Sending Message");
      }
    })
  }

  send_contact_whatsapp(btn,item)
  {
    this.shareContact(btn,item);
  }

  shareContact(btn,item) {
    this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE).then(
        result => {
          console.log('Has permission?', result.hasPermission);

          if (result.hasPermission) {
            this.Enq_file_download(btn,item);
          } else {
            this.androidPermissions.requestPermissions([this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE, this.androidPermissions.PERMISSION.READ_EXTERNAL_STORAGE]);
            this.Enq_file_download(btn,item);
          }
        },
        err => {
          console.log(err);
          this.androidPermissions.requestPermissions([this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE, this.androidPermissions.PERMISSION.READ_EXTERNAL_STORAGE]);
          this.Enq_file_download(btn,item);
        }
    );
  }

  Enq_file_download(btn,item) {

    var path='';
    var imageName='';
    var SchoolName='School_VCF';
    console.log(this.SchoolId);
    if(this.SchoolId== 1)
    {
      path = this.service.baseUrl + '/application/Contacts/SchoolOfficeNumber_GEIS.vcf';
      imageName = 'SchoolOfficeNumber_GEIS.vcf';
    }
    else if(this.SchoolId== 2)
    {
       path = this.service.baseUrl + '/application/Contacts/SchoolOfficeNumber_GWW.vcf';
      imageName = 'SchoolOfficeNumber_GWW.vcf';
    }
    else if(this.SchoolId== 3)
    {
      path = this.service.baseUrl + '/application/Contacts/SchoolOfficeNumber_GWE.vcf';
      imageName = 'SchoolOfficeNumber_GWE.vcf';
    }


    var parts = imageName.split('.');
    console.log(parts);
    var title = parts[0];
    var ext = parts[1];



    var BasePath = (this.file.externalRootDirectory || this.file.documentsDirectory);


    this.file.checkFile(BasePath, SchoolName + "/" + title + "." + ext).then(result => {
      // Success!
      console.log('File Success!');
      var localPath = BasePath + SchoolName + "/" + title + "." + ext;
      console.log("localPath", localPath);
      //this.photoViewer.show(localPath, this.SubjectName, {share: false});
      //this.socialSharing.share("test", null, localPath, null);
      this.socialSharing.shareViaWhatsApp(null, localPath, null);
      //this.socialSharing.shareViaWhatsAppToReceiver('+918087226223', null, localPath, null);
    }, err => {
      // An error occured. Show a message to the user
      console.log('File Not Exist');
      console.log(err);

      const fileTransfer: FileTransferObject = this.transfer.create();

      const url = path;
      console.log(url);
      var device_path = (this.file.externalRootDirectory || this.file.documentsDirectory);
      var targetPath = device_path + SchoolName + "/" + title + "." + ext;
      console.log("targetPath", targetPath);
      fileTransfer.download(url, targetPath).then((entry) => {
        console.log('download complete: ' + entry.toURL());
        var contentType = '';
        console.log("ext", ext);

        let postdata={
          'Id':item['Id'],
          'buttonId':btn,
          'FUserId':this.FUserId,
          'FStatusId':this.subStatusId,
          'UpdatedByName':this.userName
        }

        this.service.httppostcall('app_web_service/update_whatsup_send',postdata).subscribe(data=>{
          //this.get_process_module();
          this.socialSharing.shareViaWhatsApp(null, path, null);
        });
      }, (error) => {
        console.log("error", error);
      });
    });


  }

  send_sms(btn,item)
  {
    let data={
      FStatusId:this.subStatusId,
      FSchoolId:item['SchoolId'],
      FStandardId:item['FStandardId'],
      ButtonName:'s',
      ButtonId:btn
    }

    var link="http://geis.co.in/add_appointment.php?FWebEnquiryId="+item['FWebEnquiryId']+"&Name="+item['Name'];

    var rname = /#name/gi;
    var rschool = /#school/gi;
    var rsource = /#source/gi;
    var rdate = /#date/gi;
    var rstd = /#std/gi;

    var raptLink=/#aptlink/gi;
    var rlocation = /#location/gi;
    var rusername= /#user/gi;

    var raptdate=/#aptdate/gi
    var raptdatetime = /#aptdatetime/gi;
    var rapttime = /#apttime/gi;

    var rfeedbacklink=/#feedbacklink/gi

    var rSchoolContact1=/#ph_number_1/gi;

    var rSchoolContact2=/#ph_number_2/gi;

    var rSchoolAddress=/#address/gi;


    var feedbacklink;

    this.service.httppostcall('app_web_service/get_feedback_link?FWebEnquiryId='+item['FWebEnquiryId']+'&SchoolId='+this.SchoolId,'').subscribe(link=>{
      feedbacklink=link['link'];
    });

    this.service.httppostcall('app_web_service/get_process_message',data).subscribe(data1=>{
      console.log(data1);

      var str = data1['data']['Message'] ;


      var newstr = str. replace(rname, item['Name']);
      var newstr1   = newstr. replace(rschool,item['SchoolName']);
      var newstr2 = newstr1. replace(rsource, item['Source']);
      var newstr3 = newstr2. replace(rstd, item['StandardName']);
      var newstr4 = newstr3. replace(rdate, this.datepipe.transform(item['WebEnquiryDate'],'dd-MMM-yyyy'));
      var newstr5 = newstr4. replace(raptLink, link);
      var newstr6 = newstr5. replace(rusername, this.userName);
      var newstr7 = newstr6. replace(rlocation, item['SchoolLocation']);

      var newstr8 = newstr7. replace(raptdatetime, this.datepipe.transform(item['AppointmentDate'],'dd-MMM-yyyy') +" "+ item['AppointmentFrom'] +"-"+ item['AppointmentTo']);
      var newstr9 = newstr8. replace(rapttime,item['AppointmentFrom'] +"-"+ item['AppointmentTo']);

      var newstr10 = newstr9. replace(rfeedbacklink,feedbacklink);

      var newstr11 = newstr10. replace(raptdate,this.datepipe.transform(item['AppointmentDate'],'dd-MMM-yyyy'));

      var newstr12 = newstr11.replace(rSchoolContact1,data1['SchoolContact1']);

      var newstr13 = newstr12.replace(rSchoolContact2,data1['SchoolContact2']);

      var newstr14=newstr13.replace(rSchoolAddress,data1['SchoolAddress']);

      console.log(newstr14);


      if(data1['status'] == 'success')
      {
        let myAlert = this.alertCtrl.create({
          title: 'Select Number',
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel',
              handler: () => {
                console.log('Cancel clicked');
              }
            },
            {
              text: 'Send',
              handler: (number) => {

                console.log("number:- " + number);

                if(number == undefined || number == 'null' || number == 'undefined')
                {
                  this.presentToast('Please Select Number');
                }
                else
                {
                  let postdata={
                    'Id':item['Id'],
                    'buttonId':btn,
                    'FUserId':this.FUserId,
                    'FStatusId':this.subStatusId
                  }

                  this.service.httppostcall('app_web_service/update_sms_send',postdata).subscribe(data=>{

                    this.socialSharing.shareViaSMS(newstr14,'+91'+number);
                    //this.get_process_module();
                  });

                }




              }
            }
          ]
        });


          myAlert.addInput({
            type: 'radio',
            label: item.p1,
            value: item.p1
          })
          myAlert.addInput({
            type: 'radio',
            label: item.p2,
            value: item.p2
          })



        myAlert.present();
      }
      else
      {
        this.presentToast("Error Sending Message");
      }
    })
  }

  send_data(item){

    let msg=item.msg;
    console.log("msg->",msg);
    this.socialSharing.shareViaWhatsApp(msg, null, null);
  }

  presentToast(msg)
  {
    let toast=this.toastCtrl.create({
      message:msg,
      duration:1000
    });

    toast.present();
  }


  doRefresh(refresher)
  {

    this.get_process_module('1');

    setTimeout(() => {
      console.log('Async operation has ended');

      refresher.complete();
    }, 2000);
  }

  openWhatsup(number,msg)
  {
    this.socialSharing.shareViaWhatsAppToReceiver('+91' + number,msg,null,null);

  }

  openWhatsup_Image(number,msg)
  {
    console.log(msg);
    this.socialSharing.shareViaWhatsApp(null,msg,null);

  }

  getPendingCount(item)
  {
    if(this.subStatusId==1)
    {
      let sum = 4 - (parseInt(item.WhatsUp1, 10)+parseInt(item.WhatsUp2, 10)+parseInt(item.WhatsUp3, 10)+parseInt(item.WhatsUp4, 10));

      return 'Pending Whatsup :- ' + sum;
    }

    if(this.subStatusId==2)
    {
      let sum = 4 - (parseInt(item.WhatsUp1, 10)+parseInt(item.WhatsUp2, 10)+parseInt(item.WhatsUp3, 10)+parseInt(item.WhatsUp4, 10));

      return 'Pending Whatsup :- ' + sum;
    }

    if(this.subStatusId==3)
    {


      let sum = 6 - (parseInt(item.WhatsUp1, 10)+parseInt(item.WhatsUp2, 10)+parseInt(item.WhatsUp3, 10)+parseInt(item.WhatsUp4, 10)+parseInt(item.WhatsUp5, 10)+parseInt(item.WhatsUp6, 10));

      return 'Pending Whatsup :- ' + sum;
    }

    if(this.subStatusId==4)
    {
      let sum = 4 - (parseInt(item.WhatsUp1, 10)+parseInt(item.WhatsUp2, 10)+parseInt(item.WhatsUp3, 10)+parseInt(item.WhatsUp4, 10));

      return 'Pending Whatsup :- ' + sum;
    }

    if(this.subStatusId==5)
    {
      let sum = 4 - (parseInt(item.WhatsUp1, 10)+parseInt(item.WhatsUp2, 10)+parseInt(item.WhatsUp3, 10)+parseInt(item.WhatsUp4, 10));

      return 'Pending Whatsup :- ' + sum;
    }
  }

  getPendingsmsCount(item)
  {
    if(this.subStatusId==1)
    {
      let w1 =parseInt(item.Sms1, 10) ;
      let w2 =parseInt(item.Sms2, 10) ;
      let w3 =parseInt(item.Sms3, 10) ;

      let sum = 3 - (parseInt(item.Sms1, 10)+parseInt(item.Sms2, 10)+parseInt(item.Sms3, 10));

      return 'Pending SMS :- ' + sum;
    }

    if(this.subStatusId==2)
    {
      let sum = 3 - (parseInt(item.Sms1, 10)+parseInt(item.Sms2, 10)+parseInt(item.Sms3, 10));

      return 'Pending SMS :- ' + sum;
    }

    if(this.subStatusId==3)
    {
      let sum = 3 - (parseInt(item.Sms1, 10)+parseInt(item.Sms2, 10)+parseInt(item.Sms3, 10));

      return 'Pending SMS :- ' + sum;
    }

    if(this.subStatusId==4)
    {
      let sum = 3 - (parseInt(item.Sms1, 10)+parseInt(item.Sms2, 10)+parseInt(item.Sms3, 10));

      return 'Pending SMS :- ' + sum;
    }

    if(this.subStatusId==5)
    {
      let sum = 3 - (parseInt(item.Sms1, 10)+parseInt(item.Sms2, 10)+parseInt(item.Sms3, 10));

      return 'Pending SMS :- ' + sum;
    }
  }

  openSms(contact)
  {
    this.sanitize.bypassSecurityTrustUrl('sms:' + contact);
  }

  doInfinite(infiniteScroll) {
    if(this.IsSearch==0){
      console.log('Begin async operation');

      setTimeout(() => {
        // for (let i = 0; i < 30; i++) {
        //   this.items.push( this.items.length );
        // }
        this.page=this.page + 1;

        this.get_process_module(this.page);


        console.log('Async operation has ended');
        infiniteScroll.complete();
      }, 500);
    }else{
      console.log('Begin async operation');

      setTimeout(() => {
        // for (let i = 0; i < 30; i++) {
        console.log('Async operation has ended');
        infiniteScroll.complete();
      }, 500);
    }

  }

  openFab()
  {
    this.navCtrl.push(DataProcessModuleLogsPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/data-process-module/data-process-module.ts